export default "__VITE_ASSET__BNLErjfh__"